import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  RootPage,
  ResourcePage,
  TicketsPage,
  OrganizationInventoryRootPage,
  ClientInventoryRootPage,
} from './pages';

const InventoryPage = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.inventory.resource.root}`} component={ResourcePage} />
      <Route path={`${path}${ROUTES.dashboard.inventory.tickets.root}`} component={TicketsPage} />
      <Route path={`${path}${ROUTES.dashboard.inventory.organization.root}`} component={OrganizationInventoryRootPage} />
      <Route path={`${path}${ROUTES.dashboard.inventory.client.root}`} component={ClientInventoryRootPage} />
      <Route path={`${path}`} component={RootPage} />
    </Switch>
  );
};

export default InventoryPage;
